/*
  The MIT License

  Copyright (c) 2017-2019 EclipseSource Munich
  https://github.com/eclipsesource/jsonforms

  Permission is hereby granted, free of charge, to any person obtaining a copy
  of this software and associated documentation files (the "Software"), to deal
  in the Software without restriction, including without limitation the rights
  to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
  copies of the Software, and to permit persons to whom the Software is
  furnished to do so, subject to the following conditions:

  The above copyright notice and this permission notice shall be included in
  all copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
  AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
  LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
  OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
  THE SOFTWARE.
*/
import React, {useContext} from 'react';
import {
    ArrayLayoutProps,
    ArrayTranslations,
    RankedTester,
    isObjectArrayControl,
    isPrimitiveArrayControl,
    or,
    rankWith,
} from '@jsonforms/core';
import {
    withArrayTranslationProps,
    withJsonFormsArrayLayoutProps,
    withTranslateProps,
} from '@jsonforms/react';
import {Typography, useTheme} from "@mui/material";


import { Unwrapped } from '@jsonforms/material-renderers';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import {ArrayErrorMessagesContext} from "./Wizard";

const { MaterialArrayControlRenderer } = Unwrapped;

export const ErrorMessageArrayControlRenderer = (
    props: ArrayLayoutProps & { translations: ArrayTranslations }
) => {
    const errorMessages = useContext(ArrayErrorMessagesContext);
    const errorColor = useTheme().palette.error;

    return (
        <>
            {errorMessages.length > 0 ? <ErrorOutlineIcon style={{ color: errorColor.main }}/> : <></>}
            {errorMessages.map(message => (
                <Typography variant={"body2"} style={{ color: errorColor.main }}>{message}</Typography>)
            )}
            <MaterialArrayControlRenderer {...props} />
        </>
    );
};

export const materialArrayControlTester: RankedTester = rankWith(
    5,
    or(isObjectArrayControl, isPrimitiveArrayControl)
);

export default withJsonFormsArrayLayoutProps(
    withTranslateProps(withArrayTranslationProps(ErrorMessageArrayControlRenderer))
);
